// extracted by mini-css-extract-plugin
module.exports = {"container":"Company_container__po8dH","logo":"Company_logo__YVBst","logoImage":"Company_logoImage__f3O4A","title":"Company_title__hwyVp","delimiter":"Company_delimiter__VHUli"};